import { factory } from '@wix/web-bi-logger';
import { contextToBiEvent } from '@wix/wix-chatbot-common/browser';

import { hwPublishLog, LOG_EVENTS } from '../events/publish/widgetChannel';
import { getState } from '../store';
import { getContext } from '../utils/context';

const getQueryParam = (url: string, paramName: string): string | null => {
  if (!url) {
    return null;
  }

  try {
    return new URL(url).searchParams.get(paramName);
  } catch (e) {
    const errorMessage = `getQueryParam: could not parse URL: "${url}": ${e.message}`;
    console.error(errorMessage);
    hwPublishLog(LOG_EVENTS.BUILD_WIDGET_URL_ERROR, {
      errorMessage,
    });
    throw e;
  }
};

const biChatbot = factory({ endpoint: 'chatbot' })
  .updateDefaults({
    src: 4,
    current_page_name: document.title,
    msid: '',
    node_name: '',
  })
  .logger();

const sendBiEvent = async (data: any) => {
  const {
    widgetIframeSrc,
    chatbot: { origPageName, origPlatform },
    bi: { placement },
  } = getState();

  const context = await getContext();

  const biEventContext = contextToBiEvent(context);
  const msid = typeof data.msid === 'string' ? data.msid : context.metaSiteId;

  biChatbot.log({
    referral: getQueryParam(widgetIframeSrc, 'referral'),
    ...data,
    ...biEventContext,
    orig_page_name: origPageName,
    orig_platform: origPlatform,
    ...(msid ? { msid } : null),
    placement,
  });
};

// The user clicked a button on a tooltip
export const tooltipButtonClick = ({
  buttonId,
  buttonName,
  tooltipName,
  tooltipText,
  button_type,
  button_type_id,
}: {
  buttonId: string;
  buttonName: string;
  tooltipName: string;
  tooltipText: string;
  // button_type and button_type_id are available only for USP tooltips
  button_type?: string;
  button_type_id?: number;
}) => {
  const {
    chatbot: { conversation },
    initParams: { msid, lang },
    widgetSessionId,
  } = getState();

  sendBiEvent({
    evid: 1125,
    button_id: buttonId,
    button_name: buttonName,
    current_page_name: document.title,
    lang: conversation.lang,
    msid,
    tooltip_name: tooltipName,
    tooltip_text: tooltipText,
    lng: lang,
    button_type,
    button_type_id,
    session_id: widgetSessionId,
  });
};

// The notification about chatbot messages is displayed
export const chatbotNotificationReceived = ({ counterValue }: { counterValue: number }) => {
  sendBiEvent({
    evid: 1162,
    counter_value: counterValue,
  });
};

